// Single source of truth for the backend origin.
//
// This used to be inlined as
//   process.env.REACT_APP_API_URL || 'https://aidfone-server.onrender.com/api'
// in 12 places. That fallback is a landmine: the host is the RETIRED server. It
// still answers 200, but it is wired to the OLD Supabase project, so it returns
// plausible-looking failures ("Invalid activation code") for current customers
// instead of erroring outright. A build that lost REACT_APP_API_URL would point
// the whole dashboard at it and look like it was working.
//
// netlify.toml sets REACT_APP_API_URL per branch context, so the value is
// normally present. When it is not, fail loudly rather than guess.
const configured = process.env.REACT_APP_API_URL;

if (!configured) {
  // CRA inlines env vars at build time, so this fires for every user of a
  // misconfigured build — which is exactly when we want it to be obvious.
  // eslint-disable-next-line no-console
  console.error(
    '[AidFone] REACT_APP_API_URL is not set. API calls will fail. This build is ' +
    'misconfigured — check the branch context in netlify.toml.'
  );
}

// Empty string makes requests resolve relative to the current origin, which
// fails visibly in the network tab instead of silently hitting a dead server.
export const API_BASE_URL = configured ?? '';
